import { Toaster as SonnerToaster } from "sonner";

import { applyToastDurations, SUCCESS_TOAST_MS } from "@/lib/toast-durations";

// Applied at module scope, before any component renders, so the very first
// error of a session already gets the long duration. `lib/toast-durations.ts`
// explains why this is a patch on `toast.error` rather than a Toaster prop
// (Sonner has one global duration and no per-type override) — #1137.
applyToastDurations();

export function Toaster() {
    return (
        <SonnerToaster
            position="bottom-right"
            // The global default governs successes and plain `toast()` calls.
            // Errors and warnings override it via applyToastDurations().
            duration={SUCCESS_TOAST_MS}
            toastOptions={{
                className: "bg-card text-card-foreground border shadow-lg rounded-lg",
            }}
            richColors
            closeButton
        />
    );
}
